import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../messages';
import { openUrl } from '../../../utils';
export var ViewAction = function ViewAction(_ref) {
  var url = _ref.url;
  return {
    id: 'view-content',
    text: /*#__PURE__*/React.createElement(FormattedMessage, messages.view),
    promise: function promise() {
      return openUrl(url);
    }
  };
};